// src/data/apartments.js

const apartments = {
  // ------------------------------------
  // APARTMENTS LUX
  // ------------------------------------
  lux: {
    "1": { name: "Apartments Lux", unit: "1" },
    "2": { name: "Apartments Lux", unit: "2" },
    "3": { name: "Apartments Lux", unit: "3" },
    "4": { name: "Apartments Lux", unit: "4" }
  },

  // ------------------------------------
  // VUKOVIĆ APARTMENTS
  // ------------------------------------
  vukovic: {
    "1": { name: "Vuković Apartments", unit: "1" },
    "2": { name: "Vuković Apartments", unit: "2" },
    "3": { name: "Vuković Apartments", unit: "3" }
  },

  // ------------------------------------
  // HILLSIDE CHALET (example)
  // ------------------------------------
  hillside: {
    "1": { name: "Hillside Chalet", unit: "1" },
    "2": { name: "Hillside Chalet", unit: "2" }
  },

  dreamhouse: {
    "1": {name: "Dream House Kolasin", unit: "1"},
    "2": {name: "Dream House Kolasin", unit: "2"},
    "3": {name: "Dream House Kolasin", unit: "3"},
    "4": {name: "Dream House Kolasin", unit: "4"},
    "5": {name: "Dream House Kolasin", unit: "5"},
    "6": {name: "Dream House Kolasin", unit: "6"},
    "7": {name: "Dream House Kolasin", unit: "7"},
    "8": {name: "Dream House Kolasin", unit: "8"},
    "9": {name: "Dream House Kolasin", unit: "9"},
    "10": {name: "Dream House Kolasin", unit: "10"},
    "11": {name: "Dream House Kolasin", unit: "11"},
    "12": {name: "Dream House Kolasin", unit: "12"},
    "13": {name: "Dream House Kolasin", unit: "13"},
    "14": {name: "Dream House Kolasin", unit: "14"},
    "15": {name: "Dream House Kolasin", unit: "15"},
    "16": {name: "Dream House Kolasin", unit: "16"},
    "17": {name: "Dream House Kolasin", unit: "17"},
    "18": {name: "Dream House Kolasin", unit: "18"},
    "19": {name: "Dream House Kolasin", unit: "19"},
    "20": {name: "Dream House Kolasin", unit: "20"},
    "21": {name: "Dream House Kolasin", unit: "21"},
    "22": {name: "Dream House Kolasin", unit: "22"},
    "23": {name: "Dream House Kolasin", unit: "23"},
    "24": {name: "Dream House Kolasin", unit: "24"},
    "25": {name: "Dream House Kolasin", unit: "25"},
    "26": {name: "Dream House Kolasin", unit: "26"},
    "27": {name: "Dream House Kolasin", unit: "27"},
    "28": {name: "Dream House Kolasin", unit: "28"},
    "29": {name: "Dream House Kolasin", unit: "29"},
    "30": {name: "Dream House Kolasin", unit: "30"},
    "31": {name: "Dream House Kolasin", unit: "31"},
    "32": {name: "Dream House Kolasin", unit: "32"},
  },
  nina: {
    "1": {name: "Princeza Nina", unit: "1"},
    "2": {name: "Princeza Nina", unit: "2"},
    "3": {name: "Princeza Nina", unit: "3"},
    "4": {name: "Princeza Nina", unit: "4"},
    "5": {name: "Princeza Nina", unit: "5"},
    "6": {name: "Princeza Nina", unit: "6"},
  },

  lisicic:{
    "1": { name: "Rooms Lisicic", unit: "1" },
    "2": { name: "Rooms Lisicic", unit: "2" },
    "3": { name: "Rooms Lisicic", unit: "3" },
    "4": { name: "Rooms Lisicic", unit: "4" }
  },

  sunset:{
    "1": { name: "Sunset Apartments", unit: "1" },
  },

  montenegrina:{
    "1": { name: "Montenegrina Monte", unit: "1" },
    "2": { name: "Montenegrina Negro", unit: "2" },    
    "3": { name: "Montenegrina Chalet", unit: "3" },
  },
  sasa:{
    "1": { name: "Apartman Saša", unit: "1" },
  },
  loft:{
   "1": { name: "Apartman Loft", unit: "1" },
   "2": { name: "Apartman Loft", unit: "2" },
  },
  mirovic: {
    "1": {name: "Apartmani Mirovic", unit: "1"},
    "2": {name: "Apartmani Mirovic", unit: "2"},
    "3": {name: "Apartmani Mirovic", unit: "3"},
    "4": {name: "Apartmani Mirovic", unit: "4"},
    "5": {name: "Apartmani Mirovic", unit: "5"},
    "6": {name: "Apartmani Mirovic", unit: "6"},
    "7": {name: "Apartmani Mirovic", unit: "7"},
    "8": {name: "Apartmani Mirovic", unit: "8"},
    "9": {name: "Apartmani Mirovic", unit: "9"},
  },
  radovic:{
    "1": {name: "Apartmani Radovic", unit: "1"},
    "2": {name: "Apartmani Radovic", unit: "2"},
    "3": {name: "Apartmani Radovic", unit: "3"},
    "4": {name: "Apartmani Radovic", unit: "4"},
    "5": {name: "Apartmani Radovic", unit: "5"},
  },

  nada:{
    "1": {name: "Apartmani Nada", unit: "1"},
    "2": {name: "Apartmani Nada", unit: "2"},    
  },

  bijelipotok:{
    "2": {name: "Apartmani Bijeli Potok", unit: "2"},
    "3": {name: "Apartmani Bijeli Potok", unit: "3"},
    "4": {name: "Apartmani Bijeli Potok", unit: "4"},
    "8": {name: "Apartmani Bijeli Potok", unit: "8"},
    "9": {name: "Apartmani Bijeli Potok", unit: "9"},
    "10": {name: "Apartmani Bijeli Potok", unit: "10"},
    "11": {name: "Apartmani Bijeli Potok", unit: "11"},
  },

  holidayhomemilica:{
    "1": {name: "Holiday Home Milica", unit: "1"},
    "2": {name: "Holiday Home Milica", unit: "2"},
    "3": {name: "Holiday Home Milica", unit: "3"},
  },

  bungalovibreza:{
     "1": {name: "Bungalovi Breza", unit: "1"},
    "2": {name: "Bungalovi Breza", unit: "2"},
    "3": {name: "Bungalovi Breza", unit: "3"},
    "4": {name: "Bungalovi Breza", unit: "4"},
    "5": {name: "Bungalovi Breza", unit: "5"},
    "6": {name: "Bungalovi Breza", unit: "6"},
    "7": {name: "Bungalovi Breza", unit: "7"},
    "8": {name: "Bungalovi Breza", unit: "8"},
    "9": {name: "Bungalovi Breza", unit: "9"},
  },

  cile:{
    "8": {name: "Hotel Čile", unit: "8"},
    "9": {name: "Hotel Čile", unit: "9"},
    "10": {name: "Hotel Čile", unit: "10"},
    "11": {name: "Hotel Čile", unit: "11"},
    "12": {name: "Hotel Čile", unit: "12"},
    "13": {name: "Hotel Čile", unit: "13"},
    "14": {name: "Hotel Čile", unit: "14"},
    "15": {name: "Hotel Čile", unit: "15"},
    "16": {name: "Hotel Čile", unit: "16"},
    "17": {name: "Hotel Čile", unit: "17"},
    "18": {name: "Hotel Čile", unit: "18"},
    "19": {name: "Hotel Čile", unit: "19"},
    "20": {name: "Hotel Čile", unit: "20"},
    "21": {name: "Hotel Čile", unit: "21"},
    "22": {name: "Hotel Čile", unit: "22"},
    "23": {name: "Hotel Čile", unit: "23"},
    "24": {name: "Hotel Čile", unit: "24"},
    "25": {name: "Hotel Čile", unit: "25"},
    "26": {name: "Hotel Čile", unit: "26"},
    "27": {name: "Hotel Čile", unit: "27"},
  },

  pineviewhouse:{
    "1":{name:"Pineview House", unit:"1"}
  },
  apartmanidino:{
    "1":{name:"Apartmani Dino", unit:"1"},    
    "2":{name:"Apartmani Dino", unit:"2"}
  },
  dzudovici:{
    "1":{name:"Apartmani Džudovići", unit:"1"},   
    "2":{name:"Apartmani Džudovići", unit:"2"}, 
    "3":{name:"Apartmani Džudovići", unit:"3"}, 
  },
  eliteapartments:{
    "1":{name:"Elite Apartments", unit:"1"},   
    "2":{name:"Elite Apartments", unit:"2"}, 
    "3":{name:"Elite Apartments", unit:"3"}, 
    "4":{name:"Elite Apartments", unit:"4"}, 
    "5":{name:"Elite Apartments", unit:"5"}, 
  },
  eliterooms:{
    "1":{name:"Elite Rooms", unit:"1"},   
    "2":{name:"Elite Rooms", unit:"2"}, 
    "3":{name:"Elite Rooms", unit:"3"}, 
    "4":{name:"Elite Rooms", unit:"4"}, 
    "5":{name:"Elite Rooms", unit:"5"}, 
    "6":{name:"Elite Rooms", unit:"6"}, 
    "7":{name:"Elite Rooms", unit:"7"}, 
    "8":{name:"Elite Rooms", unit:"8"}, 
  },

  gorska:{
    "1":{name:"Apartments Gorska", unit:"1"},   
    "2":{name:"Apartments Gorska", unit:"2"}, 
    "3":{name:"Apartments Gorska", unit:"3"}, 
    "4":{name:"Apartments Gorska", unit:"4"}, 
    "5":{name:"Apartments Gorska", unit:"5"}, 
    "6":{name:"Apartments Gorska", unit:"6"}, 
  },

  greenhouse:{
    "1":{name:"Green House Apartments", unit:"1"},   
    "2":{name:"Green House Apartments", unit:"2"}, 
    "3":{name:"Green House Apartments", unit:"3"}, 
    "4":{name:"Green House Apartments", unit:"4"}, 
  },

  kucazaodmorkrujic:{
    "1":{name:"Kuca za odmor Grujić", unit:"1"},
  },
  planinskakucagrujic:{
    "1":{name:"Planinska kuća Grujić", unit:"1"},    
  },

  mojeseloscepanovic:{
    
    "1":{name:"Moje selo Sćepanović", unit:"1"},   
    "2":{name:"Moje selo Sćepanović", unit:"2"}, 
    "3":{name:"Moje selo Sćepanović", unit:"3"}, 
    "4":{name:"Moje selo Sćepanović", unit:"4"}, 
    "5":{name:"Moje selo Sćepanović", unit:"5"}, 
  },

  mrdja:{
    "1":{name:"Apartments Mrđa", unit:"1"},   
    "2":{name:"Apartments Mrđa", unit:"2"}, 
    "3":{name:"Apartments Mrđa", unit:"3"}, 
    "4":{name:"Apartments Mrđa", unit:"4"}, 
  },

  nela:{    
    "1":{name:"Apartments Nela", unit:"1"},   
  },

  roomssanja:{
    "1":{name:"Rooms Sanja", unit:"1"},   
    "2":{name:"Rooms Sanja", unit:"2"}, 
    "3":{name:"Rooms Sanja", unit:"3"}, 
  },

  apartmentssanja:{
    "1":{name:"Apartments Sanja", unit:"1"},   
    "2":{name:"Apartments Sanja", unit:"2"}, 
    "3":{name:"Apartments Sanja", unit:"3"}, 
    "4":{name:"Apartments Sanja", unit:"4"}, 
  },

  drijenak:{    
    "1":{name:"Apartments Drijenak", unit:"1"},   
    "2":{name:"Apartments Drijenak", unit:"2"},   
  },

  sanjamedenica:{
    "1":{name:"Apartments Sanja Drijenak", unit:"1"},   
    "2":{name:"Apartments Sanja Drijenak", unit:"2"},   
    "3":{name:"Apartments Sanja Drijenak", unit:"3"},   
  },
  staroognjiste:{    
    "1":{name:"Staro Ognjište", unit:"1"},   
    "2":{name:"Staro Ognjište", unit:"2"},   
    "3":{name:"Staro Ognjište", unit:"3"},   
  },

  vuk:{    
    "1":{name:"Apartments Vuk", unit:"1"},   
    "2":{name:"Apartments Vuk", unit:"2"},  
  },

  branobreza:{     
    "1":{name:"Apartments Brano, Breza", unit:"1"},  
  },

  draganrakocevic:{
    "1":{name:"Apartments Rakočević", unit:"1"},  
  },

  etnobjelasica:{    
    "1":{name:"Etno Bjelasica", unit:"1"},  
  },
  igortrifunovic:{
    "1":{name:"Apartmani Trifunović", unit:"1"},  
  },
  lovechack:{    
    "1":{name:"Love Shack", unit:"1"},  
  },
  montechalet:{
    "1":{name:"Monte Chalet", unit:"1"},  
  },
  nikolapejovic:{
    "1":{name:"Apartmani Pejovic", unit:"1"},  
  },
  vilabjelasica:{    
    "1":{name:"Vila Bjelasica", unit:"1"}, 
  }
};

export default apartments;
